// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"Navbar-primaryButton-1_8O4E","container":"Navbar-container-3VwPps","headerText":"Navbar-headerText-283W5m"};